// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","511":"cart"}[chunkId] + "." + {"177":"d66d1551","511":"7e5987d1"}[chunkId] + ".css";
};